import { createReducer } from '@reduxjs/toolkit'

import type { TGeneralConfigDto } from '@homepal/api-contract'

import { arrayToObject } from 'helpers/Functions'

import { TFetchStatus } from 'redux/reducers/Dashboards'
import { Category } from 'types/GlobalDashboardGroup'

import * as actions from '../../actions/Configs/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

interface ConfigBody {
  [key: string]: {
    category: Category
    generals: {
      [attribute: string]: TGeneralConfigDto
    }
  }
}

export interface ConfigReducerType {
  data: ConfigBody
  fetchStatus: TFetchStatus
}

const INITIAL_STATE: ConfigReducerType = {
  data: {},
  fetchStatus: 'idle'
}

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAll, (state) => {
      state.fetchStatus = 'fetching'
    })
    .addCase(actions.getAllSuccess, (state, action) => {
      const data: ConfigBody = {}

      action.payload.data.forEach((config) => {
        data[config.category] = {
          category: config.category,
          generals: arrayToObject(config.generals, 'attribute') as {
            [attribute: string]: TGeneralConfigDto
          }
        }
      })

      state.data = data
      state.fetchStatus = 'success'
    })
    .addCase(actions.getAllFailed, (state) => {
      state.fetchStatus = 'error'
    })
    .addCase(actions.updateSuccess, (state, action) => {
      action.payload.data.forEach((config) => {
        state.data[config.category].generals = arrayToObject(
          config.generals,
          'attribute'
        ) as {
          [attribute: string]: TGeneralConfigDto
        }
      })
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})
